export default "__VITE_ASSET__DWI40H64__"